import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import getEnv from "../environment";

const {
  apiUrl,
  firebaseApiKey,
  firebaseAuthDomain,
  firebaseProjectId,
  firebaseStorageBucket,
  firebaseMessagingSenderId,
  firebaseAppId,
} = getEnv();

const firebaseConfig = {
  apiKey: firebaseApiKey,
  authDomain: firebaseAuthDomain,
  projectId: firebaseProjectId,
  storageBucket: firebaseStorageBucket,
  messagingSenderId: firebaseMessagingSenderId,
  appId: firebaseAppId,
};

const app = initializeApp(firebaseConfig);

// Talk to the Firebase Auth emulator whenever we're pointed at a local
// API, instead of the real, live bodyart-322618 project -- keyed off
// apiUrl rather than __DEV__, since a production-mode build (e.g.
// `expo build:web`, used for one-off staging test deploys) can still be
// aimed at a local backend and should follow it to the local emulator,
// not silently fall back to the real project.
if (apiUrl && apiUrl.includes("localhost")) {
  connectAuthEmulator(getAuth(app), "http://localhost:9099", {
    disableWarnings: true,
  });
}

export default app;
